// Add these types to your existing utils/types.ts file

// Integration Types
export enum IntegrationType {
  PIPEDRIVE_API_KEY = "pipedrive_api_key",
  PIPEDRIVE_OAUTH = "pipedrive_oauth",
  GOHIGHLEVELV1 = "gohighlevelv1", // uses API key
  GOHIGHLEVELV2 = "gohighlevelv2", // uses OAuth
  FOURDEMR = "4demr",
  AIRTABLE_TOP_AESTHETICS = "airtable_top_aesthetics",
  DRCHRONO = "drchrono",
  GENERIC_WEBHOOK = "webhook",
  META_PIXEL = "meta_pixel",
}

export type TPipedriveOAuthCredentials = {
  client_id: string;
  client_secret: string;
};

export type TPipedriveApiKeyCredentials = {
  api_key: string;
};

export type TPipedriveLeadConfig = {
  create_as?: "lead" | "deal";
  pipeline_id?: number;
  stage_id?: number;
  user_id?: number;
};

export type TMetaPixelCredentials = {
  access_token: string;
};

export type TMetaPixelConfig = {
  pixel_id: string;
  track_page_view?: boolean;
};

export type TWebhookFieldMapping = {
  target_field: string;
  source_path?: string | null;
  default_value?: string | null;
  literal_value?: string | null;
  include_if_none?: boolean;
};

export type TWebhookIntegrationConfig = {
  webhook_url: string;
  http_method?: "POST";
  headers?: Record<string, string>;
  field_mappings: TWebhookFieldMapping[];
};

export type TIntegrationCredentials =
  | TPipedriveOAuthCredentials
  | TPipedriveApiKeyCredentials
  | TMetaPixelCredentials
  | null;

export type TIntegrationConfig =
  | TPipedriveLeadConfig
  | TMetaPixelConfig
  | TWebhookIntegrationConfig
  | undefined;

export type TCreateIntegrationRequest = {
  integration_type: IntegrationType;
  credentials?: TIntegrationCredentials;
  config?: TIntegrationConfig;
  is_active?: boolean;
  auto_sync_notes?: boolean | null;
};

export type TIntegration = {
  integration_id: number;
  clinic_uuid: string;
  integration_type: IntegrationType;
  credentials?: TIntegrationCredentials;
  config?: TIntegrationConfig;
  auto_sync_notes?: boolean | null;
  is_active: boolean;
};

export type TExchangePipedriveTokenRequest = {
  code: string;
};

export type TExchangePipedriveTokenResponse = {
  message: string;
  access_token: string;
};

export type TExchangeDrChronoTokenRequest = {
  code: string;
};

export type TExchangeDrChronoTokenResponse = {
  message: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
};

export type TDrChronoAuthUrlResponse = {
  auth_url: string;
};

export type TRefreshDrChronoTokenRequest = {
  refresh_token: string;
};

export type TRefreshDrChronoTokenResponse = {
  message: string;
  access_token: string;
  refresh_token: string;
  expires_in: number;
};

export type TSyncRequest = {
  access_token: string;
  clinic_uuid?: string;
};
